import { Link } from "react-router-dom"
import { Location } from "../../Interfaces"
import { useContext } from "react"
import UiContext from "../../context/uiProvider"
import DataContext from "../../context/dataProvider"
import { TABLET } from "../../utils/screenSize"
import { AREA_MANAGER } from "../../utils/roles"

interface LocationHeaderProps {
  location: Location
  activeTab?: string
  organizationName?: string
  managementCompanyName?: string
}

export default function LocationHeader({
  location,
  activeTab = "Walk Reports",
  organizationName,
  managementCompanyName
}: LocationHeaderProps) {
  const { deviceView } = useContext(UiContext)
  const { currentUser } = useContext(DataContext)

  return (
    <>
      {/* Header Section */}
      <section className="bg-secondary-extra-light p-2 md:rounded-lg mb-2 shadow-lg">
        <div className="bg-primary-dark flex flex-col">
          <div className="text-white rounded-lg p-4">
            <div className={`${deviceView > TABLET && "flex"}`}>
              <div className="mr-5">
                <h3 className="">{location.name}</h3>
                <h4 className="">{location.address}</h4>
                <h4 className="">{`${location.city}, ${location.state} ${location.zipcode}`}</h4>
              </div>
              <div>
                {managementCompanyName && (
                  <h4>
                    Management Company:<span className="text-base">{" " + managementCompanyName}</span>
                  </h4>
                )}
                <h4 className="">
                  Area:<span className="text-base">{" " + organizationName}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tabs */}
      <div className="bg-white shadow-lg rounded-lg mb-4">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            <Link
              to={`../locations/${location.id}`}
              className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Walk Reports"
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Walk Reports
            </Link>
            <Link
              to={`../locations/${location.id}`}
              className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Employees"
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Employees
            </Link>
            <Link
              to={`../locations/${location.id}`}
              className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Incidents"
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Incidents
            </Link>
            <Link
              to={`../locations/${location.id}/create-walks`}
              className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Setup Walks"
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
            >
              Setup Walks
            </Link>
            {currentUser?.roleId && currentUser.roleId >= AREA_MANAGER && (
              <Link
                to={`../locations/update/${location.id}`}
                className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === "Update Location"
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
              >
                Update Location
              </Link>
            )}
          </nav>
        </div>
      </div>
    </>
  )
} 